import { type ReactNode, createContext, useContext, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type NumbersLayerStore } from 'pages/settings/pages/numbers/store/numbersLayerStore'
import { AddNumberFromAppStepsStore } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/store/AddNumberFromAppStepsStore'

const AddNumberFromAppStepsContext = createContext<AddNumberFromAppStepsStore | null>(null)

export const useAddNumberFromAppStepsContext = () => {
  const context = useContext(AddNumberFromAppStepsContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with AddNumberFromAppStepsContext'
    )

  return context
}

export const AddNumberFromAppStepsProvider = ({
  numbersLayerStore,
  children,
}: {
  numbersLayerStore: NumbersLayerStore
  children: ReactNode
}) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new AddNumberFromAppStepsStore(numbersLayerStore, entities), [])

  return (
    <AddNumberFromAppStepsContext.Provider value={store}>
      {children}
    </AddNumberFromAppStepsContext.Provider>
  )
}
